interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="px-3 h-9 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
              page === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-foreground-500 text-sm">
            {page}
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="px-3 h-9 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}